export enum EMediaType {
  Image = 'IMAGE',
  Video = 'VIDEO',
  Gif = 'GIF',
}
